import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Item} from "../../models/Item";
import {ObjectConfig} from "../../models/ObjectConfig";
import {ToolsService} from "../../services/toolsService/tools.service";
import {ItemManagerService} from '@src/app/services/itemManager/item-manager.service';

@Component({
  selector: 'app-exchange-items',
  templateUrl: './exchange-items.component.html',
  styleUrls: ['./exchange-items.component.scss']
})
export class ExchangeItemsComponent implements OnInit {

  @Input() selectedItems: Item[];
  @Output() closeGroup = new EventEmitter<any>();
  public selectedTool = null;
  public categoryTools: Item[];
  private modelItems: Item[];
  public Yiit = Yiit;

  constructor(private toolsAdapter: ToolsService, private im: ItemManagerService) { }

  get isContainCategories(){
    return this.categoryTools.length > 0;
  }

  get getItemTextByToolsCount(){
    return this.categoryTools.length > 1 ? 'these items' : 'this item';
  }

  ngOnInit() {
    this.modelItems = this.selectedItems.filter((item)=>{
      return item.config.getTool().type == ObjectConfig.TYPE_FIXED_FIGURE
    });

    let toolsId = new Map();
    this.modelItems.forEach((item)=>{
      toolsId.set(item.config.getTool().id, item.config.getTool());
    })

    let isOnlyOneTool = toolsId.size == 1;

    this.categoryTools = this.toolsAdapter.getToolsInCategory(this.modelItems[0].config.getTool().category).filter((tool: any) => {
      if (isOnlyOneTool){
        return tool.type == ObjectConfig.TYPE_FIXED_FIGURE && tool.id != this.modelItems[0].config.getToolId()
      }
      return tool.type == ObjectConfig.TYPE_FIXED_FIGURE
    });
  }

  setNewConfigToItems(event){

    //parentSeenIds - "Set" of uniq parents for each copy that hasn't parent in modelItems (could be few copies with one parent)
    let parentSeenIds = new Set();
    this.modelItems
      //filter all copies from modelItems
      .filter(i =>
      {
        if (i.config.isCopy){
          if (!parentSeenIds.has(i.config.getCopyParentId)){
            parentSeenIds.add(i.config.getCopyParentId);
          }
          return false;
        }
        return true;
      })
      //add all parents to modelItems
      .concat([...parentSeenIds].map(id => this.im.getItemById(id)))
      //filter empty elements
      .filter(i => Boolean(i))
      //set new tool for each item
      .forEach((item)=>{
        this.setNewConfigToSingleItem(item, event);
    });
    this.selectedTool = event;
    this.closeGroup.emit(true);
  }

  setNewConfigToSingleItem(item, tool){

    let newTool = Object.assign({}, tool);
    this.toolsAdapter.assignMappings(newTool);

    if (this.selectedTool.name != item.config.getTitle()){
         newTool.name = item.config.getTitle();
      }

    let object = {
      tool: newTool,
      position: item.config.getObjectConfig().getCenterPosition(),
      rotation: item.config.getRotation()
    };

    const inputValues = JSON.parse(JSON.stringify(item.config.getInputs()));

    let newItemCopy = this.getModelItemConfigByTool(object, inputValues, item);
    newItemCopy.id = item.config.getId();

    item.config.assignWithSave(newItemCopy);

    item.getObservable('toolSwitched').next(newTool);
  }

  private getModelItemConfigByTool(object:{tool,position,rotation}, inputValues?, item?){

    let tool = object.tool;
    let position = object.position;
    let rotation = object.rotation;
    let fixedSize = {fixed_height: null, fixed_width: null, fixed_width_px: null};

    const getColor = (fieldName: string) => {
      const defColor = tool.default_color.toString().trim();
      const requiredColor = (tool[fieldName]) ? tool[fieldName].toString().trim() : '';
      return requiredColor.length > 0
        ? requiredColor
        : defColor.length > 0
          ? defColor
          : '#000000';
    };

    if (tool.params){
      if (tool.params.hasOwnProperty('fixedHeight')){
        fixedSize.fixed_height = tool.params['fixedHeight'].value;
      }
      if (tool.params.hasOwnProperty('fixedWidth')){
        fixedSize.fixed_width = tool.params['fixedWidth'].value;
      }
      if (tool.params.hasOwnProperty('fixedWidthPx')){
        fixedSize.fixed_width_px = tool.params['fixedWidthPx'].value;
      }
    }

    let inputs = JSON.parse(JSON.stringify(tool.params));
    if (!inputs){
      inputs = {};
    }
    if (inputValues) {
      for (const i in inputValues) {
        if (inputValues && inputValues.hasOwnProperty(i) && !inputValues[i].hasOwnProperty('calculation')) {
          if (inputs.hasOwnProperty(i) && inputValues[i].hasOwnProperty('value')) {
            inputs[i].value = inputValues[i].value;
          } else {
            inputs[i] = inputValues[i];
          }
        }
      }
    }

    let _preparedItem = {

      id: null,
      group: tool.category.name,
      title: tool.name,
      originalTitle: tool.name,
      toolId: tool.id,
      copyOf: item ? item.config.getCopyParentId: null,
      copyDirection: item ? item.config.copyDirection: null,
      copyGapInMeters: item ? item.config.copyGapInMeters: null,
      creator: window['PROFILE']['name'],
      creatorEmail: window['PROFILE']['email'],
      createdAt: Math.round(Date.now() / 1000),
      objects: [{
        area: null,
        icon: {},
        map_icon: tool.map_icon,
        latLngs: position,
        length: null,
        center: position,
        originalPosition: position,
        position: position,
        radius: position,
        rotation: rotation,
        tool_id: tool.id,
        tool_type: tool.type,
        fixed_height: fixedSize.fixed_height || tool.fixed_height_meters,
        fixed_width: fixedSize.fixed_width || tool.fixed_width_meters,
        fixed_width_px: fixedSize.fixed_width_px || (tool.params && tool.params['fixedWidthPx']) ? tool.params['fixedWidthPx'] : null,
        fillColor: getColor('fill_color'),
        fillOpacity: (tool.default_opacity.toString().trim().length > 0) ? tool.default_opacity : 1,
        strokeColor: getColor('line_color'),
        strokeWeight:  tool.hasOwnProperty('map_configs')
        && tool.map_configs.hasOwnProperty('cesium')
        && tool.map_configs.cesium.hasOwnProperty('line_width') ? tool.map_configs.cesium.line_width : tool.line_thickness || 0,
      }],
      inputs: inputs
    };
    return _preparedItem;
  }


}
